import React from 'react';
import { Pnevmatika } from '../../types/pnevmatika';
import { Modal } from '../common/Modal/Modal';
import { Button } from '../common/Button/Button';
import './DuplicateConfirmationModal.css';

interface DuplicateConfirmationModalProps {
  isOpen: boolean;
  existingPnevmatike: Pnevmatika[];
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export const DuplicateConfirmationModal: React.FC<DuplicateConfirmationModalProps> = ({
  isOpen,
  existingPnevmatike,
  onClose,
  onConfirm,
  loading = false
}) => {
  if (!existingPnevmatike || existingPnevmatike.length === 0) {
    return null;
  }

  const formatDate = (dateString: string): string => {
    return new Date(dateString).toLocaleDateString('sl-SI');
  };

  const tireNumber = existingPnevmatike[0].oznaka_gume;
  const count = existingPnevmatike.length;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Pnevmatika${count > 1 ? 'e' : ''} s to oznako že obstaja${count > 1 ? 'jo' : ''}`}
    >
      <div className="duplicate-confirmation">
        <p className="duplicate-message">
          {count === 1 ? (
            <>Pnevmatika z oznako <strong>{tireNumber}</strong> že obstaja v sistemu.</>
          ) : (
            <>Najdenih je <strong>{count}</strong> pnevmatik z oznako <strong>{tireNumber}</strong>.</>
          )}
        </p>
        
        {existingPnevmatike.map((pnevmatika, index) => (
          <div key={pnevmatika.id} className="existing-pnevmatika-details">
            <h4>Obstoječi podatki {count > 1 ? `(${index + 1}/${count}):` : ':'}</h4>
            <div className="detail-row">
              <span className="label">Ime:</span>
              <span className="value">{pnevmatika.ime}</span>
            </div>
            <div className="detail-row">
              <span className="label">Priimek:</span>
              <span className="value">{pnevmatika.priimek}</span>
            </div>
            <div className="detail-row">
              <span className="label">Telefonska številka:</span>
              <span className="value">{pnevmatika.telefonska_stevilka}</span>
            </div>
            <div className="detail-row">
              <span className="label">Oznaka pnevmatike:</span>
              <span className="value">{pnevmatika.oznaka_gume}</span>
            </div>
            <div className="detail-row">
              <span className="label">Spravljeno od:</span>
              <span className="value">{formatDate(pnevmatika.spravljeno_od)}</span>
            </div>
          </div>
        ))}

        <p className="duplicate-warning">
          Ali ste prepričani, da želite vseeno {count > 1 ? 'dodati novo pnevmatiko' : 'shraniti spremembe'} z isto oznako?
        </p>

        <div className="duplicate-actions">
          <Button
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Prekliči
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            loading={loading}
          >
            Vseeno {count > 1 ? 'dodaj' : 'shrani'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
